import React from 'react';

export default function SmartiLabShell({ children }) {
  return <div className="sl-theme lab-shell">{children}</div>;
}
